<template>
  <b-pagination id="page" size="sm" class="mt-3" align="fill"
                :total-rows="pagination.totalRows"
                :per-page="pagination.perPage"
                v-model="pagination.currentPage" />
</template>

<script>
  export default {
    name: "Pagination",

    props: {
      pagination: {
        currentPage: {
          type: Number,
          required: true
        },
        totalRows: {
          type: Number,
          required: true
        },
        perPage: {
          type: Number,
          required: true
        }
      }
    }
  }
</script>
